import { RootState } from 'store/rootReducer';
import { selectorsFactory } from 'store/entities/utils';
import * as keyWindowNames from './keyWindowNames';

export const adminOrganizationsParentAutoCompleteSlice = (state: RootState) =>
  state.entities.adminOrganizationsParentAutoComplete;

export const adminOrganizationsParentAutoComplete = selectorsFactory.createStaticKeyWindowEntitiesMemoizedSelector(
  adminOrganizationsParentAutoCompleteSlice,
);

export const adminOrganizationsParentAutoCompleteState = selectorsFactory.createDynamicKeyWindowStateMemoizedSelector(
  adminOrganizationsParentAutoCompleteSlice,
  keyWindowNames.adminOrganizationsSearch,
);

export const adminOrganizationsParentAutoCompletePaginationState =
  selectorsFactory.createDynamicKeyWindowPaginationSelector(
    adminOrganizationsParentAutoCompleteSlice,
    keyWindowNames.adminOrganizationsSearch,
  );
